import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/header.css";
import { NavLink } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import { IoIosCall } from "react-icons/io";
import { RxCross1 } from "react-icons/rx";
import { Typeahead } from "react-bootstrap-typeahead";
import { useSelector } from "react-redux";
import { MediaSidebarData } from "./MediaSidebarData";
import MediaSidebarItem from "./MediaSidebarItem";
import { RxCross2 } from "react-icons/rx";
import logo from "../images/logos/matel-logo1.jpg";
import logo1 from "../images/logos/matel-logo.png";

import { MdEmail, MdAccessTime } from "react-icons/md";
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import { RiMenu3Fill } from "react-icons/ri";

const Header = () => {
  const overlayRef = useRef(null);
  const navbarRef = useRef(null);
  const navToggleBtnRef = useRef(null);
  const headerRef = useRef(null);
  const navbarLinksRef = useRef([]);
  const location = useLocation();
  const productState = useSelector((state) => state?.product?.product);
  const isDesktop = useMediaQuery({ minWidth: 768 });

  const [productOpt, setProductOpt] = useState([]);
  const [paginate, setPaginate] = useState(true);
  const navigate = useNavigate();

   const [searchTerm, setSearchTerm] = useState("");
  const [sidebarMain, setSidebarMain] = useState(false); // For fixed header
  const [sidebarOverlay, setSidebarOverlay] = useState(false); // For absolute header

  const queryParams = new URLSearchParams(location.search);
  const searchQuery = queryParams.get("search");

  useEffect(() => {
    const overlay = overlayRef.current;
    const navbar = navbarRef.current;
    const navToggleBtn = navToggleBtnRef.current;
    const header = headerRef.current;
    const navbarLinks = navbarLinksRef.current;

    const navToggleFunc = () => {
      if (!overlay || !navbar || !navToggleBtn) return;
      navToggleBtn.classList.toggle("active");
      navbar.classList.toggle("active");
      overlay.classList.toggle("active");
      document.body.style.overflow = overlay.classList.contains("active") ? "hidden" : "auto";
    };

    if (navToggleBtn && overlay && navbarLinks.length > 0) {
      navToggleBtn.addEventListener("click", navToggleFunc);
      overlay.addEventListener("click", navToggleFunc);
      navbarLinks.forEach((link) => {
        if (link) link.addEventListener("click", navToggleFunc);
      });
    }

    const handleScroll = () => {
      if (!header) return;
      if (location.pathname === "/" || location.pathname === "/ ") {
        if (window.scrollY <= 1000) {
          header.classList.remove("active");
        } else {
          header.classList.add("active");
        }
      } else {
        header.classList.add("active");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      if (navToggleBtn && overlay && navbarLinks.length > 0) {
        navToggleBtn.removeEventListener("click", navToggleFunc);
        overlay.removeEventListener("click", navToggleFunc);
        navbarLinks.forEach((link) => {
          if (link) link.removeEventListener("click", navToggleFunc);
        });
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location]);

  const [showSearch, setShowSearch] = useState(false);
  const handleToggleSearch = () => {
    setShowSearch(!showSearch);
  };

  useEffect(() => {
    const query = searchQuery ? searchQuery.toLowerCase() : "";
    const suggestions = new Set(productOpt);

    productState.forEach((item) => {
      const titleWords = item.title.toLowerCase().split(" ");
      const brand = item.brand ? item.brand.toLowerCase() : "";

      if (brand.includes(query)) {
        suggestions.add(brand);
      }
      if (item.title.toLowerCase().includes(query)) {
        suggestions.add(item.title);
      }
      if (item.type && item.type.toLowerCase().includes(query)) {
        suggestions.add(item.type);
      }

      titleWords.forEach((word) => {
        if (word.includes(query)) {
          suggestions.add(word);
        }
      });
    });

    setProductOpt(Array.from(suggestions));
  }, [productState, searchQuery]);

  const handleSuggestionSelect = (selected) => {
    if (selected.length > 0) {
      const selectedSuggestion = selected[0];
      navigate(`/warehouse?search=${selectedSuggestion}`);
      setShowSearch(!showSearch);
    }
  };

  // ✅ Separate sidebar toggles
  const toggleOverlaySidebar = () => {
    setSidebarOverlay(!sidebarOverlay);
    document.body.classList.toggle("sidebar-active", !sidebarOverlay);
  };

  const toggleMainSidebar = () => {
    setSidebarMain(!sidebarMain);
    document.body.classList.toggle("sidebar-active", !sidebarMain);
  };

  return (
    <>
      <div className="header__wrapper">
        {/* ---------- Absolute Header ---------- */}
     <header className="header-2">
   {!isDesktop && 
   <div className="container-2">
    <div className="logo overlay__logo">
             <img src={logo} alt="logo" />
             <p>Matel Trading Motors</p>
              
            </div>

  {/* --- Overlay Sidebar --- */}
  <div className="header-menu-container">
    <div
      key="sidebar-overlay"
      className={sidebarOverlay ? "sidebar active" : "sidebar"}
    >
      <div>
        <div className="sidebar-header">
          <div className="logo">
            <img src={logo} alt="logo" />
          </div>

          <RxCross2
            className="cross-btn"
            onClick={toggleOverlaySidebar}
          />
        </div>

        <div className="sidebar__lists-container">
          {MediaSidebarData.map((item, index) => (
            <MediaSidebarItem
              key={index}
              item={item}
              onClick={toggleOverlaySidebar}
            />
          ))}
        </div>
      </div>

      <div className="sidebar-social-media">
        <a
          className="social-icon"
          href="https://facebook.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebookF />
        </a>

        <a
          className="social-icon"
          href="https://instagram.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram />
        </a>

        <a
          className="social-icon"
          href="https://twitter.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaTwitter />
        </a>

        <a
          className="social-icon"
          href="https://linkedin.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedinIn />
        </a>
      </div>
    </div>

    <RiMenu3Fill
      className="menu-icon"
      onClick={toggleOverlaySidebar}
    />
  </div>

   

</div>

   }
  
   {isDesktop && 
          <div className={`header-bottom-container ${location.pathname === "/" ? "" : "hidden__overlay"}`}>
         
           <div className="logo overlay__logo">
             <img src={logo} alt="logo" />
             <p>Matel Trading Motors</p>
              
            </div>
          

            <nav className="navbar-2">
              <ul className="navbar-list-2">
                <li>
                  <NavLink to="/" className={({ isActive }) => `navbar-link2${isActive ? " active" : ""}`}>
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/vehicles" className={({ isActive }) => `navbar-link2${isActive ? " active" : ""}`}>
                    Inventory
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/enroute" className={({ isActive }) => `navbar-link2${isActive ? " active" : ""}`}>
                    Enroute
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/import-guide" className={({ isActive }) => `navbar-link2${isActive ? " active" : ""}`}>
                    Import With Us
                  </NavLink>
                </li>
                 <li>
                  <NavLink to="/imports" className={({ isActive }) => `navbar-link2${isActive ? " active" : ""}`}>
                    Shop From Japan
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/blogs" className={({ isActive }) => `navbar-link2${isActive ? " active" : ""}`}>
                    Blogs
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/contact-us" className={({ isActive }) => `navbar-link2${isActive ? " active" : ""}`}>
                    Contact
                  </NavLink>
                </li>
              </ul>
            </nav>

    <div className="header-actions">
      <div className={`search-container ${showSearch ? "active" : ""}`}>
        <Typeahead
          id="pagination-example"
           onChange={handleSuggestionSelect}
           options={productOpt}
            paginate={paginate}
            labelKey={"name"}
            minLength={2}
            className="search-box"
            placeholder="Search here..."
           />
        {showSearch ? (
          <RxCross1 className="search__cross-icon" onClick={handleToggleSearch} />
        ) : (
          <CiSearch className="search__icon " onClick={handleToggleSearch} />
        )}
      </div>
    </div>

          </div>
           } 
        </header>   

        {/* ---------- Fixed Header ---------- */}
        <header className={`header ${location.pathname === "/" ? "" : "relative-header"}`} data-header ref={headerRef}>
          <div className="container-x">
            <NavLink to="/" className="logo">
              <img src={logo} alt="logo" />
              <p className="logo__name">Matel Trading Motors</p>
            </NavLink>

            <nav className="navbar" data-navbar ref={navbarRef}>
              <ul className="navbar-list">
                <li>
                  <NavLink to="/" className={({ isActive }) => `navbar-link${isActive ? " active" : ""}`} data-nav-link>
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/vehicles" className={({ isActive }) => `navbar-link${isActive ? " active" : ""}`} data-nav-link>
                     Inventory
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/enroute" className={({ isActive }) => `navbar-link${isActive ? " active" : ""}`} data-nav-link>
                    Enroute
                  </NavLink>
                </li>
                 <li>
                  <NavLink to="/import-guide" className={({ isActive }) => `navbar-link2${isActive ? " active" : ""}`}>
                    Import With Us
                  </NavLink>
                </li>
                 <li>
                  <NavLink to="/imports" className={({ isActive }) => `navbar-link2${isActive ? " active" : ""}`}>
                    Shop From Japan
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/blogs" className={({ isActive }) => `navbar-link2${isActive ? " active" : ""}`}>
                   Blogs
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/contact-us" className={({ isActive }) => `navbar-link${isActive ? " active" : ""}`} data-nav-link>
                    Contact
                  </NavLink>
                </li>
              </ul>
            </nav>

            {isDesktop && (
    <div className="header-actions">
      <div className={`search-container-2 ${showSearch ? "active" : ""}`}>
        <Typeahead
          id="pagination-example"
           onChange={handleSuggestionSelect}
           options={productOpt}
            paginate={paginate}
            labelKey={"name"}
            minLength={2}
            className="search-box"
            placeholder="Search here..."
           />
        {showSearch ? (
          <RxCross1 className="search__cross-icon-2" onClick={handleToggleSearch} />
        ) : (
          <CiSearch className="search__icon-2" onClick={handleToggleSearch} />
        )}
      </div>
    </div>
            )}

            {/* --- Main Sidebar --- */}
            <div className="header-menu-container">
              <div key="sidebar-main" className={sidebarMain ? "sidebar active" : "sidebar"}>
                <div>
                  <div className="sidebar-header">
                    <div className="logo">
                      <img src={logo} alt="logo" />
                    </div>
                    <RxCross2 className="cross-btn" onClick={toggleMainSidebar} />
                  </div>

                  <div className="sidebar__lists-container">
                    {MediaSidebarData.map((item, index) => (
                      <MediaSidebarItem key={index} item={item} onClick={toggleMainSidebar} />
                    ))}
                  </div>
                </div>

                <div className="sidebar-social-media">
                  <a className="social-icon" href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <FaFacebookF />
                  </a>
                  <a className="social-icon" href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <FaInstagram />
                  </a>
                  <a className="social-icon" href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                    <FaTwitter />
                  </a>
                  <a className="social-icon" href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <FaLinkedinIn />
                  </a>
                </div>
              </div>

              <RiMenu3Fill className="menu-icon" onClick={toggleMainSidebar} />
            </div>
          </div>
        </header>
      </div>
    </>
  );
};

export default Header;
